// If required, this can be polyfilled using https://www.npmjs.com/package/clipboard-polyfill
export default navigator.clipboard
